export const hasActiveSubscription = (
  endDate?: string | null,
  now = new Date()
) => {
  if (!endDate) return false;

  const endTime = new Date(endDate).getTime();
  if (Number.isNaN(endTime)) return false;

  return endTime > now.getTime();
};
